(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-airflow"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.airflow-popup');
    const trigger = document.querySelector('.mini-airflow-trigger');
    const overlay = document.querySelector('.airflow-popup .popup-overlay');
    const close = document.querySelector('.airflow-popup .popup-close');

    trigger.addEventListener('click', function () {
      popup.classList.add('open');
    });

    overlay.addEventListener('click', function () {
      popup.classList.remove('open');
    });

    close.addEventListener('click', function () {
      popup.classList.remove('open');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-child-mode"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        var popupTrigger = document.querySelector('.child-mode-popup-trigger');
        var popup = document.querySelector('.child-mode-popup');
        var popupOverlay = document.querySelector('.child-mode-popup .popup-overlay');
        var popupClose = document.querySelector('.child-mode-popup .popup-close');

        popupTrigger.addEventListener('click', function(){
            popup.classList.add('open');
        });

        popupOverlay.addEventListener('click', function(){
            popup.classList.remove('open');
        });

        popupClose.addEventListener('click', function(){
            popup.classList.remove('open');
        });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-colors"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){
    const miniColors = document.querySelectorAll('.mini-color');
    const miniColorTitle = document.querySelector('.mini-color-title');

    miniColors.forEach(miniColor => {
        miniColor.addEventListener('click', function(){
            const index = this.getAttribute('data-index');
            miniColors.forEach(miniColor => miniColor.classList.remove('is-active'));
            this.classList.add('is-active');
            document.querySelectorAll('.mini-colors-image img').forEach(image => image.style.display = 'none');
            document.querySelector(`.mini-colors-image img:nth-child(${index})`).style.display = 'block';
            miniColorTitle.innerHTML = this.getAttribute('data-title');
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-hairdryer-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const hairdryerBanner = $('.mini-hairdryer-banner');
    const endPoint = $(window).outerHeight() * 3;
    const tagline_image = $('.tagline-image');
    const banner_product = $('.banner-product');
    const banner_product_info = $('.banner-product-info');
    const banner_features = $('.mini-banner-features');
    const banner_features_inner = $(".mini-banner-features .features-list");
    const banner_features_items = $(".mini-banner-features .feature");

    let bannerTl;
    function miniHdBanner() {
      if (bannerTl) bannerTl.revert();
      bannerTl = gsap.timeline({
        scrollTrigger: {
          trigger: hairdryerBanner,
          start: 'top top',
          end: () => `${endPoint} bottom`,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      bannerTl.fromTo(tagline_image,
        { 
          x: -200, 
          opacity: 0 
        },
        { 
          x: -10, 
          opacity: 1, 
          ease: 'none',
          duration: 2
        }
      )
      bannerTl.fromTo(banner_product,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2,
          delay: 5 
        }
      )
      bannerTl.fromTo(banner_product_info,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2,
          onStart: function(){
            banner_product.addClass('appear');
          },
          onReverseComplete: function(){
            banner_product.removeClass('appear');
          } 
        }
      )
      bannerTl.to(banner_product_info,{
        yPercent: -100,
        opacity: 0,
        duration: 10,
        delay: 5 
      })
      bannerTl.fromTo(banner_features,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none'
        },
        "-=7"
      )
      bannerTl.fromTo(banner_features_inner,
        { 
          yPercent: 100, 
        },
        { 
          yPercent: -50, 
          ease: 'none',
          duration: 10,
        },
        "-=12"
      )

      bannerTl.fromTo(banner_features_items, 
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 4,
                stagger: 2
            },
            "-=10"
        )

    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (bannerTl) {
          bannerTl.revert();
          bannerTl.clear();
        }
        miniHdBanner();
      }
      lw = window.innerWidth;
    });
    miniHdBanner();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-hotspot"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const hotspots = document.querySelectorAll('.hotspot');
    const popups = document.querySelectorAll('.hotspot-popup');
    const popupClose = document.querySelectorAll('.popup-close');
    hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', function(){
        const id = this.getAttribute('data-id');
        const popup = document.querySelector(`.hotspot-popup[data-id="${id}"]`);
        popup.classList.add('open');
      });
    });
    popups.forEach(popup => {
      popup.addEventListener('click', function(){
        this.classList.remove('open');
      });
    });
    popupClose.forEach(close => {
      close.addEventListener('click', function(e){
        e.stopPropagation();
        this.closest('.hotspot-popup').classList.remove('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-image-slider"] && !window.DesignMode) return;
  try {
    
    const miniImageSlider = new Flickity('.mini-image-slider', {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: true,
        groupCells: true,
        prevNextButtons: true
    });

    let start = null;
    let duration = 5000;
    function updateDot(time){
      if(!start) start = time;
      let progress = time - start;
      let scaleX = progress / duration;
      $('.mini-image-slider .flickity-page-dots')[0].style.setProperty('--scaleX', scaleX);
      if(progress < duration){
        requestAnimationFrame(updateDot);
      }else{
        start = null;
        miniImageSlider.next();
        $('.mini-image-slider .flickity-page-dots')[0].style.setProperty('--scaleX', 0);
        requestAnimationFrame(updateDot);
      }
    }
    requestAnimationFrame(updateDot);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-size-details"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const miniSizeSection = $('.mini-size-details');
    const sizeText = miniSizeSection.find('.mini-size-text');
    const endPoint = $(window).outerHeight() * 2;

    const lengthLine1 = miniSizeSection.find('.length-lines span:nth-child(1)');
    const lengthLine2 = miniSizeSection.find('.length-lines span:nth-child(2)');
    const lengthLine3 = miniSizeSection.find('.length-lines span:nth-child(3)');
    const lengthValue = miniSizeSection.find('.length-value');
    
    const heightLine1 = miniSizeSection.find('.height-lines span:nth-child(1)');
    const heightLine2 = miniSizeSection.find('.height-lines span:nth-child(2)');
    const heightLine3 = miniSizeSection.find('.height-lines span:nth-child(3)');
    const heightValue = miniSizeSection.find('.height-value');

    let sizeTL;
    function miniSize() {
      if (sizeTL) sizeTL.revert();
      sizeTL = gsap.timeline({
        scrollTrigger: {
          trigger: miniSizeSection,
          start: 'top top',
          end: () => `+=${endPoint}`,
          anticipatePin: 1,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      sizeTL.fromTo(sizeText,
        {
          opacity: 1
        },
        {
          opacity: 0,
          duration: 1
        }
      );
      sizeTL.fromTo(lengthLine1,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(heightLine1,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthLine2,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        }
      );
      sizeTL.fromTo(heightLine2,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthLine3,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        }
      );
      sizeTL.fromTo(heightLine3,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthValue,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(heightValue,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1
        },
        '<'
      );
    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (sizeTL) {
          sizeTL.revert();
          sizeTL.clear();
        }
        miniSize();
      }
      lw = window.innerWidth;
    });
    miniSize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-weight"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const miniWeightSection = $('.mini-weight-section');
    const endPoint = $(window).outerHeight() * 2;
    const mini_weight_text_1 = miniWeightSection.find('.mini-weight-text-1');
    const mini_weight_text_2 = miniWeightSection.find('.mini-weight-text-2');
    const mini_weight_text_footer = miniWeightSection.find('.mini-weight-text-footer');

    let weightTl;
    function miniWeightBanner() {
      if (weightTl) weightTl.revert();
      weightTl = gsap.timeline({
        scrollTrigger: {
          trigger: miniWeightSection,
          start: 'top top',
          end: () => `+=${endPoint} bottom`,
          anticipatePin: 1,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      weightTl.fromTo(mini_weight_text_1,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        }
      ).fromTo(mini_weight_text_footer,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        },
        '<'
      ).to(mini_weight_text_1,
        { 
          opacity: 0, 
          ease: 'none',
          duration: 2,
          delay: 3
        }
      );
      weightTl.fromTo(mini_weight_text_2,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        },
        '-=1'
      )

    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (weightTl) {
            weightTl.revert();
            weightTl.clear();
        }
        miniWeightBanner();
      }
      lw = window.innerWidth;
    });
    miniWeightBanner();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-banner-v4"] && !window.DesignMode) return;
  try {
    
$('.pillar-banner-hotspot button').on('click', function(){
    const content = $(this).closest('.pillar-banner-hotspot').find('.hotspot-popup-content').html();
    $('.pillar-banner-hotspot button').not(this).removeClass('active');
    $(this).toggleClass('active');
    $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').html(content);
    if($(this).hasClass('active')){
        $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').addClass('active');
    }else{
        $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').removeClass('active');
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toothbrush-comparison"] && !window.DesignMode) return;
  try {
    
$('.color-swatch').click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    const index = $(this).index();
    const parent = $(this).parents('.wave-product-column');
    const activeProduct = parent.find('.wave-product').eq(index);
    const url = activeProduct.data('url');
    activeProduct.addClass('active').siblings().removeClass('active');
    parent.find('.wave-product-button a').attr('href', url);
});

  } catch(e) { console.error(e); }
})();
})();
